export default {"src":"/_next/static/media/uploadCloud.126d4508.svg","height":24,"width":25};